/*
 * @Author: Chao Yang
 * @Date: 2020-12-15 09:40:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-03-07 13:21:00
 */
import { BaseProxy } from '../base.proxy';
import { Observable } from 'rxjs';
import { IConfiguration } from '../../model/configuration/iConfiguration.model';
import { IDateRange } from '../../model/dashboard';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ConfigurationProxy extends BaseProxy {
  GetDateRange(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<IConfiguration<IDateRange>> {
    if (environment.feature.newApi === false) {
      return this._http.post<IConfiguration<IDateRange>>(
        `/ip/api/dashboard/configuration/daterange`,
        accounts
      );
    } else {
      return this._http.get<IConfiguration<IDateRange>>(
        `/ip-api/api/dashboard/daterange`
      );
    }
  }

  UpdateDateRange(config: IConfiguration<IDateRange>) {
    return this._http.put(`/ip/api/dashboard/configuration/daterange`, config);
  }
}
